import { Offcanvas } from "react-bootstrap";
import HelperService from "../../utility/HelperService";

interface Props {
    show: boolean;
    handleClose: () => void;
    data: any;
    tab: "EVENT" | "PLAN" | "RESOURCE";
}

/* ================= HELPERS ================= */
const decimal = (v: any) => {
    if (!v) return 0;
    if (typeof v === "number") return v;
    if (v?.$numberDecimal) return Number(v.$numberDecimal);
    return Number(v) || 0;
};

const Section = ({ title, children }: { title: string; children: any }) => (
    <>
        <h6 className="text-primary mb-3">{title}</h6>
        {children}
        <hr />
    </>
);

const Detail = ({ label, value }: { label: string; value: any }) => (
    <div className="row mb-2">
        <div className="col-5 text-muted">{label}</div>
        <div className="col-7 fw-semibold">{value ?? "-"}</div>
    </div>
);

/* ================= COMPONENT ================= */
const ViewTransactionDetails = ({ show, handleClose, data, tab }: Props) => {
    if (!data) return null;

    const isEvent = tab === "EVENT";

    /* -------- COMMON -------- */
    const status = isEvent ? data.payment?.status : data.status;
    const paymentMethod = isEvent
        ? data.payment?.method === "MANNUAL"
            ? "Manual"
            : "Online"
        : data.paymentMethod == "Admin Payment" || data.paymentMethod == "manual" ? "Manual" : "Online";
    const transactoionId = isEvent ? data.payment?.gatewayId : data.paymentGatewayId;

    /* -------- PLAN / RESOURCE -------- */
    const billing = data.transactionBillingDetail || {};
    const normalizedBilling = {
        country:
            typeof billing.country === "object"
                ? billing.country?.name
                : billing.country || "-",

        state:
            typeof billing.state === "object"
                ? billing.state?.name
                : billing.state || "-",

        city:
            typeof billing.city === "object"
                ? billing.city?.name
                : billing.city || "-",
    }
    // const country = billing.country || {};
    // const state = billing.state || {};
    // const city = billing.city || {};

    /* -------- EVENT -------- */
    const coupon = data.coupon || {};
    const eventBilling = data.billing || {};
    const address = eventBilling.address || {};
    const event = data.event || {};

    const entityLabel =
        tab === "EVENT"
            ? "Event"
            : tab === "PLAN"
                ? "Plan"
                : "Resource";

    const entityName =
        tab === "EVENT"
            ? data.event?.title
            : tab === "PLAN"
                ? data.plan?.planName
                : data.report?.title;

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" className="offcanvas-custom">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Transaction Details</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
                <div className="card shadow-sm p-3">

                    <Section title="Entity Details">
                        <Detail label={entityLabel} value={entityName} />
                    </Section>

                    {/* ================= TRANSACTION ================= */}
                    <Section title="Transaction Details">
                        {/* <Detail label="Invoice Number" value={data.invoiceNumber} /> */}
                        {/* <Detail label="Order No" value={data.orderNo} /> */}
                        <Detail label="Transaction ID" value={transactoionId} />
                        <Detail label="Payment Method" value={paymentMethod} />
                        <Detail
                            label="Payment Status"
                            value={<span className={`badge ${status === "PAID" ? "bg-success" : status === "FAILED" ? "bg-danger" : "bg-warning"}`}>{status}</span>}
                        />
                        <Detail
                            label="Transaction Date"
                            value={HelperService.dateFormatter(data.createdAt)}
                        />
                    </Section>

                    {/* ================= PAYMENT SUMMARY ================= */}
                    <Section title="Payment Summary">
                        <Detail
                            label="Sub Total"
                            value={`₹${isEvent ? decimal(data.subTotal) : decimal(data.subTotal)}`}
                        />
                        <Detail
                            label="Discount"
                            value={`₹${isEvent ? decimal(data.discountedAmount) : decimal(data.discountedAmount)}`}
                        />
                        <Detail
                            label="Coupon Code"
                            value={isEvent ? coupon.code : data.couponCode}
                        />
                        <Detail
                            label="Tax"
                            value={`₹${isEvent ? decimal(data.taxAmount) : decimal(data.taxAmount)}`}
                        />
                        <Detail
                            label="Total Amount"
                            value={`₹${decimal(data.totalAmount)}`}
                        />
                    </Section>

                    {/* ================= BILLING DETAILS ================= */}
                    <Section title="Billing Details">
                        {isEvent ? (
                            <>
                                <Detail label="GST Credit" value={eventBilling.isGstCredit ? "Yes" : "No"} />
                                <Detail label="Company Name" value={eventBilling.companyName} />
                                <Detail label="GST Number" value={eventBilling.gstNumber} />
                                <Detail label="Name" value={address.name} />
                                <Detail label="Email" value={address.email} />
                                <Detail label="Phone" value={address.phone} />
                                <Detail label="Address" value={address.addressLine} />
                                <Detail label="ZIP" value={address.zip} />
                            </>
                        ) : tab === "RESOURCE" ? (
                            <>
                                <Detail label="Company Name" value={billing.companyName} />
                                <Detail label="Name" value={billing.name} />
                                <Detail label="Email" value={billing.email} />
                            </>
                        ) : (
                            <>
                                <Detail label="Company Name" value={billing.companyName} />
                                <Detail label="GST Number" value={billing.gstNumber} />
                                <Detail label="Name" value={billing.name} />
                                <Detail label="Email" value={billing.email} />
                                <Detail label="Address" value={billing.address} />
                                <Detail label="Country" value={normalizedBilling.country} />
                                <Detail label="State" value={normalizedBilling.state} />
                                <Detail label="City" value={normalizedBilling.city} />
                                <Detail label="ZIP" value={billing.zip} />
                            </>
                        )}
                    </Section>

                    {/* ================= EVENT EXTRA ================= */}
                    {/* {isEvent && (
            <Section title="Event Details">
              <Detail label="Event Name" value={event.title} />
              <Detail label="Discount Type" value={coupon.discountType} />
              <Detail label="Discount Value" value={coupon.discountValue} />
              <Detail label="Tax %" value={coupon.taxPercentage} />
              <Detail label="Currency" value={coupon.currency} />
            </Section>
          )} */}

                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ViewTransactionDetails;
